import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('as-toolbar')
export class Toolbar extends LitElement {
  public static styles = css`
    .toolbar {
      border-bottom: 1px solid #d9d9d9;
      padding-bottom: 8px;
      margin-bottom: 16px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
    }

    .toolbar-items {
      flex: 1 1;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .toolbar-items-left {
      justify-content: flex-start;
    }

    .toolbar-items-right {
      justify-content: flex-end;
    }

    .toolbar-caption {
      flex: 0 0 auto;
      text-align: center;
      font-family: 'Segoe UI Light', 'Segoe UI', 'Lucida Sans', 'Arial', sans-serif;
      color: #555555;
      font-size: 24px;
      font-weight: lighter;
    }
  `;

  @property()
  public caption!: string;

  public render() {
    return html`
      <div class="toolbar">
        <div class="toolbar-items toolbar-items-left">
          <slot name="left-items"></slot>
        </div>
        <div class="toolbar-caption">${this.caption}</div>
        <div class="toolbar-items toolbar-items-right">
          <slot name="right-items"></slot>
        </div>
      </div>
    `;
  }
}
